import { rgba } from "polished";
import styled, { css } from "styled-components";

export const Container = styled.form`
  border: 1px solid ${(props) => props.theme.colors.scale[500]};
  width: 100%;
  padding: 14px 16px;
  border-radius: 5px;
  /* uma grade so para campos e acoes: com flex os campos empurravam uns aos
     outros e sobrava um buraco entre o ultimo campo e os botoes */
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
  align-items: end;
  gap: 14px;

  /* o select nativo que o Radix mantem escondido e filho da grade e estava
     ocupando uma celula inteira */
  select[aria-hidden="true"],
  [data-radix-select-hidden] {
    position: absolute;
    pointer-events: none;
  }
  box-shadow: rgba(0, 0, 0, 0.1) 0px 6px 10px;
  position: relative;
  ${(props) =>
    props.waiting &&
    css`
      overflow: hidden;
      cursor: not-allowed;
      border-color: ${(props) => props.theme.colors.gray[500]};
      background: ${(props) => rgba(props.theme.colors.gray[500], 0.2)};
      &::before {
        content: "⚠️ Em Construção";
        box-shadow: ${(props) => rgba(props.theme.colors.black, 0.2)} 1px 1px
          4px;
        position: absolute;
        background: ${(props) => props.theme.colors.scale[500]};
        left: 0;
        top: 0;
        font-weight: bold;
        padding: 5px 10px;
        color: ${(props) => props.theme.colors.background};
        font-size: 12px;
        border-radius: 0 0 5px 0;
      }
    `}
`;

export const FilterContainer = styled.div`
  /* nao e uma caixa: os campos entram direto na grade do Filter.Root, para
     ficarem na mesma cadencia de colunas que os botoes */
  display: contents;
`;

export const FilterActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 12px;

  /* ocupa as duas ultimas colunas da fila onde cair: os campos preenchem as
     celulas antes dela, entao nao sobra buraco no meio */
  grid-column: span 2 / -1;

  @media (max-width: 760px) {
    grid-column: 1 / -1;
  }
`;
